module.exports = __webpack_public_path__ + "static/media/wish-icon.6ecac5a3.svg";